// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"aa759957","288":"5771b2ac","787":"29891671","867":"a1c603d7"}[chunkId] + ".chunk.js";
};